import {
    CANCEL_NOTIFICATIONS_EDITOR,
    CancelNotificationsEditor,
    CHANGE_INTERVAL_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR,
    CHANGE_NOTIFICATION_DISABLE_VALUE_FOR_NOTIFICATIONS_EDITOR,
    CHANGE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR,
    CHANGE_NOTIFICATION_VALUE_FOR_NOTIFICATIONS_EDITOR,
    CHANGE_PERCENT_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR,
    CHANGE_PHONE_FOR_NOTIFICATIONS_EDITOR,
    CHANGE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR,
    CHANGE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR,
    ChangeIntervalNotificationForNotificationsEditor,
    ChangeNotificationDisableValueForNotificationsEditor,
    ChangeNotificationValueForNotificationsEditor,
    ChangePercentNotificationForNotificationsEditor,
    CLOSE_NOTIFICATIONS_EDITOR,
    NotificationEditorAction,
    OPEN_NOTIFICATIONS_EDITOR,
    UPDATE_NOTIFICATIONS_EDITOR_VALIDATION_DATA,
    UpdateNotificationsEditorValidationData,
    VALIDATE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR,
    VALIDATE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR,
    VALIDATE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR,
    ValidateSmsEndTimeForNotificationsEditor,
    ValidateSmsStartTimeForNotificationsEditor
} from '../actions/notificationsEditor';
import { HOURS_PER_DAY, MINUTES_PER_HOUR } from '../constants';
import { getNotificationsEditorDataFromNotificationsValue } from '../mappers/campaignsEdit/campaignsEdit';
import {
    validateCommonFieldsNotificationEditor,
    validateNotificationItem
} from '../service/NotificationEditorHelper/NotificationEditorHelper';
import {
    formatTimeNumberToString,
    formatTimeStringToNumber,
    getTimeStringWithFillingZeros,
    roundMinuteTimeByCurrentValue
} from '../service/TimeHelper/TimeHelper';
import {
    NotificationEditorsState,
    NotificationType
} from '../typings/notificationEditor';
import { State } from '../typings/state';

export const changeNotificationValueForNotificationsEditor = (
    state: NotificationEditorsState,
    action: ChangeNotificationValueForNotificationsEditor
): NotificationEditorsState => {
    const { notifications } = state[action.editorId];
    const { index } = action;

    return {
        ...state,
        [action.editorId]: {
            ...state[action.editorId],
            notifications: [
                ...notifications.slice(0, index),
                {
                    ...notifications[index],
                    value: !notifications[index].value
                },
                ...notifications.slice(index + 1, notifications.length)
            ]
        }
    };
};

export const changeIntervalNotificationForNotificationsEditor = (
    state: NotificationEditorsState,
    action: ChangeIntervalNotificationForNotificationsEditor
): NotificationEditorsState => {
    const { notifications } = state[action.editorId];
    const { index } = action;
    const currentNotification = notifications[index];

    if (currentNotification.type !== NotificationType.changeTrafficValue) {
        return state;
    }

    return {
        ...state,
        [action.editorId]: {
            ...state[action.editorId],
            notifications: [
                ...notifications.slice(0, index),
                {
                    ...currentNotification,
                    interval: action.interval
                },
                ...notifications.slice(index + 1, notifications.length)
            ]
        }
    };
};

export const changePercentNotificationForNotificationsEditor = (
    state: NotificationEditorsState,
    action: ChangePercentNotificationForNotificationsEditor,
    fullState: State
): NotificationEditorsState => {
    const {
        commonData: { constants }
    } = fullState;
    const { notifications } = state[action.editorId];
    const { index } = action;

    const newNotificationItem = {
        ...notifications[index],
        percent: action.percent
    };

    return {
        ...state,
        [action.editorId]: {
            ...state[action.editorId],
            notifications: [
                ...notifications.slice(0, index),
                {
                    ...newNotificationItem,
                    errors: validateNotificationItem(
                        newNotificationItem,
                        constants
                    )
                },
                ...notifications.slice(index + 1, notifications.length)
            ]
        }
    };
};

export const validateSmsStartTimeForNotificationsEditor = (
    state: NotificationEditorsState,
    action: ValidateSmsStartTimeForNotificationsEditor
): NotificationEditorsState => {
    const {
        smsInterval: { inputStartTime, startTime }
    } = state[action.editorId];
    const inputStartTimeWithFillingZeros = getTimeStringWithFillingZeros(
        inputStartTime
    );
    const parsedStartTime = formatTimeStringToNumber(
        inputStartTimeWithFillingZeros
    );

    let newValueSmsInterval = {
        startTime: startTime,
        inputStartTime: formatTimeNumberToString(startTime)
    };

    if (parsedStartTime !== undefined) {
        const roundedStartTime = roundMinuteTimeByCurrentValue(
            parsedStartTime,
            15
        );
        const newInputStartTime = formatTimeNumberToString(roundedStartTime);

        newValueSmsInterval = {
            startTime: roundedStartTime,
            inputStartTime: newInputStartTime
        };
    }

    return {
        ...state,
        [action.editorId]: {
            ...state[action.editorId],
            smsInterval: {
                ...state[action.editorId].smsInterval,
                ...newValueSmsInterval
            }
        }
    };
};

export const validateSmsEndTimeForNotificationsEditor = (
    state: NotificationEditorsState,
    action: ValidateSmsEndTimeForNotificationsEditor
): NotificationEditorsState => {
    const {
        smsInterval: { inputEndTime, endTime }
    } = state[action.editorId];
    const inputEndTimeWithFillingZeros = getTimeStringWithFillingZeros(
        inputEndTime
    );
    const parsedEndTime = formatTimeStringToNumber(
        inputEndTimeWithFillingZeros
    );

    let newValueSmsInterval = {
        endTime: endTime,
        inputEndTime: formatTimeNumberToString(endTime)
    };

    if (parsedEndTime !== undefined) {
        const minutesAtDay = HOURS_PER_DAY * MINUTES_PER_HOUR;
        let roundedEndTime = roundMinuteTimeByCurrentValue(parsedEndTime, 15);
        roundedEndTime =
            roundedEndTime > minutesAtDay ? minutesAtDay : roundedEndTime;
        const newInputEndTime = formatTimeNumberToString(roundedEndTime);

        newValueSmsInterval = {
            endTime: roundedEndTime,
            inputEndTime: newInputEndTime
        };
    }

    return {
        ...state,
        [action.editorId]: {
            ...state[action.editorId],
            smsInterval: {
                ...state[action.editorId].smsInterval,
                ...newValueSmsInterval
            }
        }
    };
};

export const cancelNotificationsEditor = (
    state: NotificationEditorsState,
    action: CancelNotificationsEditor,
    fullState: State
): NotificationEditorsState => {
    const newEditorValue = getNotificationsEditorDataFromNotificationsValue(
        action.value
    );
    const currentEditor = state[action.editorId];
    const { isChangedPhone } = currentEditor;

    return {
        ...state,
        [action.editorId]: {
            ...newEditorValue,
            isOpen: false,
            isChangedPhone
        }
    };
};

export const changeNotificationDisableValueForNotificationsEditor = (
    state: NotificationEditorsState,
    action: ChangeNotificationDisableValueForNotificationsEditor
): NotificationEditorsState => {
    const { notifications } = state[action.editorId];
    const { index, value: disabledValue } = action;
    const currentNotification = notifications[index];

    return {
        ...state,
        [action.editorId]: {
            ...state[action.editorId],
            notifications: [
                ...notifications.slice(0, index),
                {
                    ...currentNotification,
                    value: disabledValue ? false : currentNotification.value,
                    disabled: disabledValue
                },
                ...notifications.slice(index + 1, notifications.length)
            ]
        }
    };
};

export const updateNotificationsEditorValidationData = (
    state: NotificationEditorsState,
    action: UpdateNotificationsEditorValidationData
): NotificationEditorsState => {
    const editor = state[action.editorId];
    const { validationData } = action;

    const newNotifications = editor.notifications.map(
        (itemNotification, index) => {
            return {
                ...itemNotification,
                errors: validationData.notifications[index]
            };
        }
    );

    return {
        ...state,
        [action.editorId]: {
            ...state[action.editorId],
            notifications: newNotifications,
            errors: validationData.common
        }
    };
};

export function notificationEditor(
    state: NotificationEditorsState = {},
    action: NotificationEditorAction,
    fullState: State
): NotificationEditorsState {
    switch (action.type) {
        case OPEN_NOTIFICATIONS_EDITOR:
            const notificationEditorsData = getNotificationsEditorDataFromNotificationsValue(
                action.value
            );
            const lastEditorData = state[action.editorId];

            return {
                ...state,
                [action.editorId]: {
                    ...lastEditorData,
                    ...notificationEditorsData,
                    isOpen: true,
                    isChangedPhone: lastEditorData
                        ? lastEditorData.isChangedPhone
                        : false
                }
            };

        case CLOSE_NOTIFICATIONS_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    isOpen: false
                }
            };

        case CANCEL_NOTIFICATIONS_EDITOR:
            return cancelNotificationsEditor(state, action, fullState);

        case UPDATE_NOTIFICATIONS_EDITOR_VALIDATION_DATA:
            return updateNotificationsEditorValidationData(state, action);

        case CHANGE_NOTIFICATION_VALUE_FOR_NOTIFICATIONS_EDITOR:
            return changeNotificationValueForNotificationsEditor(state, action);

        case CHANGE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    email: action.email
                }
            };

        case VALIDATE_NOTIFICATION_EMAIL_FOR_NOTIFICATIONS_EDITOR:
            // здесь будет валидация email
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    errors: validateCommonFieldsNotificationEditor(
                        state[action.editorId]
                    )
                }
            };

        case CHANGE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    smsInterval: {
                        ...state[action.editorId].smsInterval,
                        inputStartTime: action.startTime
                    }
                }
            };

        case VALIDATE_SMS_START_TIME_FOR_NOTIFICATIONS_EDITOR:
            return validateSmsStartTimeForNotificationsEditor(state, action);

        case CHANGE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    smsInterval: {
                        ...state[action.editorId].smsInterval,
                        inputEndTime: action.endTime
                    }
                }
            };

        case VALIDATE_SMS_END_TIME_FOR_NOTIFICATIONS_EDITOR:
            return validateSmsEndTimeForNotificationsEditor(state, action);

        case CHANGE_INTERVAL_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR:
            return changeIntervalNotificationForNotificationsEditor(
                state,
                action
            );

        case CHANGE_PERCENT_NOTIFICATION_FOR_NOTIFICATIONS_EDITOR:
            return changePercentNotificationForNotificationsEditor(
                state,
                action,
                fullState
            );

        case CHANGE_NOTIFICATION_DISABLE_VALUE_FOR_NOTIFICATIONS_EDITOR:
            return changeNotificationDisableValueForNotificationsEditor(
                state,
                action
            );

        case CHANGE_PHONE_FOR_NOTIFICATIONS_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    isChangedPhone: true
                }
            };
        default:
            return state;
    }
}
